import { X, AlertCircle, ShoppingCart } from "lucide-react";
import { useEffect } from "react";

interface ModalConflictoCarritoProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    tipo: 'fecha' | 'tipo_despacho';
    mensaje: string;
    fechaCarrito?: string;
    fechaNueva?: string;
}

const ModalConflictoCarrito = ({
    isOpen,
    onClose,
    onConfirm,
    tipo,
    mensaje,
    fechaCarrito,
    fechaNueva
}: ModalConflictoCarritoProps) => {
    
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const getTitulo = () => {
        if (tipo === 'fecha') {
            return '⚠️ Conflicto en tu Pedido';
        }
        return '⚠️ Conflicto en tu Pedido';
    };

    const getMensajeDetallado = () => {
        if (tipo === 'fecha') {
            return 'Todos los productos en tu carrito deben tener la misma fecha de entrega. No es posible mezclar productos con fechas diferentes en un mismo pedido.';
        }
        return 'No puedes mezclar productos con diferentes métodos de entrega en un mismo pedido. Debes elegir solo Despacho a Domicilio o solo Retiro en Local para todos tus productos.';
    };

    return (
        <>
            {/* Overlay */}
            <div 
                className="fixed inset-0 bg-black/50 z-[999] transition-opacity duration-300"
                onClick={onClose}
            />
            
            {/* Modal */}
            <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4">
                <div 
                    className="bg-white rounded-2xl shadow-2xl max-w-md w-full animate-in zoom-in-95 duration-300"
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Header */}
                    <div className="flex items-center justify-between p-6 border-b border-gray-200">
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center">
                                <AlertCircle className="w-6 h-6 text-yellow-600" />
                            </div>
                            <h3 className="text-lg font-bold text-gray-900">
                                {getTitulo()}
                            </h3>
                        </div>
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-600 transition-colors"
                        >
                            <X className="w-6 h-6" />
                        </button>
                    </div>

                    {/* Content */}
                    <div className="p-6 space-y-4">
                        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r-lg">
                            <p className="text-gray-700 leading-relaxed">
                                {getMensajeDetallado()}
                            </p>
                        </div>

                        {tipo === 'fecha' && fechaCarrito && fechaNueva && (
                            <div className="space-y-2">
                                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                                    <span className="text-sm font-medium text-gray-600">Fecha en carrito:</span>
                                    <span className="text-sm font-bold text-[#790546]">{fechaCarrito}</span>
                                </div>
                                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                                    <span className="text-sm font-medium text-gray-600">Fecha que intentas agregar:</span>
                                    <span className="text-sm font-bold text-gray-900">{fechaNueva}</span>
                                </div>
                            </div>
                        )}

                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                            <p className="text-sm text-blue-800 font-semibold mb-2">
                                ¿Qué deseas hacer?
                            </p>
                            <ul className="space-y-2 text-sm text-blue-700">
                                <li className="flex items-start gap-2">
                                    <span className="text-blue-500 mt-0.5">✓</span>
                                    <span><strong>Vaciar y agregar:</strong> Elimina todos los productos actuales y agrega este nuevo producto</span>
                                </li>
                                <li className="flex items-start gap-2">
                                    <span className="text-blue-500 mt-0.5">✓</span>
                                    <span><strong>Cancelar:</strong> Mantiene tu carrito actual sin cambios</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="flex gap-3 p-6 bg-gray-50 rounded-b-2xl">
                        <button
                            onClick={onClose}
                            className="flex-1 px-4 py-3 bg-white border-2 border-gray-300 text-gray-700 font-semibold rounded-lg hover:bg-gray-50 transition-colors"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={onConfirm}
                            className="flex-1 px-4 py-3 bg-[#790546] text-white font-semibold rounded-lg hover:bg-[#5a0334] transition-colors flex items-center justify-center gap-2"
                        >
                            <ShoppingCart className="w-5 h-5" />
                            Vaciar y Agregar
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ModalConflictoCarrito;
